$(function() {
  const selector = 'a.js-pdbox';
	const buttonSelector = 'input.js-pdbox, button.js-pdbox';
	const videoSelector = '.js-pdboxVideo';


	$(document).on('click', '.js-pdbox-html', function (e) {
		e.preventDefault();
    const pdBox = window.pdBox || initializePdBox();

		const $el = $( $(this).attr('href')).clone();
		$el.removeClass('js-hide');

    pdBox.box.openHtml($el, $(this));

    pdBox.box.window.elem.find('form').each(function () {
        window.Nette.initForm(this);
    });
	});

	const openAjax = function(e) {
    const pdBox = window.pdBox || initializePdBox();
		if ( ! (e.button || e.ctrlKey || e.shiftKey || e.altKey || e.metaKey)) {
			if ($(this).data('pdboxTarget') === 'new' && pdBox.box.isOpen) {
				pdBox.innerBox.open($(this), selector);

			} else {
				pdBox.box.open($(this), selector);
			}

			e.preventDefault();
		}
	};

	$(document).on('click', selector, function (e) {
		$.proxy(openAjax, this, e)();
	});

	$(document).on('click', buttonSelector, function (e) {
		const valid = Nette.validateForm($(this).closest('form')[0]);
		if ( ! valid) {
			e.preventDefault();
			e.stopPropagation();

			return;
		}

		$.proxy(openAjax, this, e)();
	});

	$(document).on('click', videoSelector, function (e) {
    const pdBox = window.pdBox || initializePdBox();
		const href = this.href;
		const html = '<div class="video-wrap"><iframe width="560" height="315" src="'+href+'" frameborder="0" allowfullscreen></iframe></div>';

		if ($(this).data('thickboxTarget') === 'new' && pdBox.box.isOpen) {
			pdBox.innerBox.openHtml(html, $(this));
		} else {
			pdBox.box.openHtml(html, $(this));
		}

		e.preventDefault();
	});

	$(document).on('click', '.detail-video a', function (e) {
		const href = this.href;
		const $box = $(this).closest('.detail-video-wrap');
		const html = '<div class="wrap-in"><iframe width="560" height="315" src="'+href+'?rel=0&amp;showinfo=0&amp;autoplay=1&amp;controls=1" frameborder="0" allowfullscreen></iframe></div>';

		$box.html(html);
		e.preventDefault();
	});

	//newsletter sale for email
	$('.newsletter-sale-for-email, .closing-popup-info').each(function () {
		const $popup = $(this);
		const popup = new $.pdBox({
			isAjax: false
		});

		popup.openHtml($popup, $popup);
	});
});
